import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

@Component({
  selector: 'app-book-sellerpracel-labels',
  templateUrl: './book-sellerpracel-labels.component.html',
  styleUrls: ['./book-sellerpracel-labels.component.scss']
})
export class BookSellerpracelLabelsComponent implements OnInit {

  groups: any[] = [];
  snackBar: any;

  constructor(
    private dialogRef: MatDialogRef<BookSellerpracelLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    console.log('RAW DATA =>', this.data);

    const raw = Array.isArray(this.data?.addresslabels)
      ? this.data.addresslabels
      : Array.isArray(this.data)
      ? this.data
      : [];

    this.prepareData(raw);
  }

  prepareData(raw: any[]): void {

    if (!raw || raw.length === 0) {
      this.groups = [];
      return;
    }

    this.groups = raw.map((group: any) => ({

      DistributiveRep:
        group?.DistributiveRep || 'अनिर्धारित',

      records: (group?.records || []).map((item: any) => {

        const totalBookCopies =
          Number(item?.total_book_copies ?? 0);

        const jyda =
          Number(item?.jyda ?? 0);

        return {

          bse_id: item?.bse_id ?? '',
          booking_id: item?.booking_id ?? '',

          booking_no: item?.booking_no ?? '',
          booking_date: item?.booking_date ?? '',

          DeliveryMode:
            item?.DeliveryMode ?? '',

          DistributionMode:
            item?.DistributionMode ?? '',

          dis_sub_mode:
            item?.dis_sub_mode ?? '',

          rep_name:
            item?.rep_name ?? '',

          year:
            item?.year ?? '',

          month:
            item?.month ?? '',

          state:
            (item?.state ?? '').trim(),

          district:
            (item?.district ?? '').trim(),

          taluka:
            (item?.taluka ?? '').trim(),

          address:
            (item?.address ?? '').trim(),

          pincode:
            (item?.pincode ?? '').trim(),

          mobile_no:
            (item?.mobile_no ?? '').trim(),

          total_book_copies:
            totalBookCopies,

          jyda:
            jyda,

          grand_total:
            totalBookCopies + jyda,

          row_total:
            Number(item?.row_total ?? 0),

          book_names:
            item?.book_names ?? ''
        };
      })
    }));

    console.log('FINAL GROUPS =>', this.groups);
  }

printPage(): void {

  const section = document.getElementById('print-section');
  if (!section) return;

  const allCards = Array.from(section.querySelectorAll('.card'));
  if (!allCards.length) return;

  const pages: string[] = [];

  for (let i = 0; i < allCards.length; i += 2) {

    const chunk = allCards.slice(i, i + 2);

    const pageHTML = `
      <div class="page">
        ${chunk.map(card => `<div class="card-slot">${card.innerHTML}</div>`).join('')}
      </div>
    `;

    pages.push(pageHTML);
  }

  const win = window.open('', '_blank', 'width=1200,height=800');
  if (!win) return;

  win.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print</title>
        <meta charset="utf-8">

        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          body {
            font-family: Arial, Helvetica, sans-serif;
            background: #fff;
          }

          /* ===== A3 LANDSCAPE PAGE ===== */
          .page {
            width: 440mm;
            height: 290mm;

            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;

            gap: 20px;
            padding: 10px;

            page-break-after: always;
            break-after: page;
          }

          /* ===== CARD ===== */
          .card-slot {
            border: 2px solid #1a5fa8;
            border-radius: 8px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            background: #fff;
            padding: 15px;
          }

          /* Increase font size for ALL content */
          .card-slot,
          .card-slot * {
            font-size: 28px !important;
            line-height: 1.5 !important;
            font-family: Arial, Helvetica, sans-serif !important;
          }

          /* Bigger headings */
          .card-slot h1 {
            font-size: 42px !important;
            margin-bottom: 10px;
          }

          .card-slot h2 {
            font-size: 36px !important;
            margin-bottom: 8px;
          }

          .card-slot h3 {
            font-size: 32px !important;
            margin-bottom: 6px;
          }

          .card-slot p,
          .card-slot span,
          .card-slot div,
          .card-slot td,
          .card-slot th,
          .card-slot label,
          .card-slot li {
            font-size: 28px !important;
          }

          img {
            max-width: 180px !important;
            height: auto !important;
            object-fit: contain;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          td,
          th {
            padding: 6px;
          }

          @page {
            size: A3 landscape;
            margin: 8mm;
          }

          @media print {
            body {
              margin: 0;
            }

            .page {
              page-break-after: always;
              break-after: page;
            }
          }
        </style>
      </head>

      <body onload="window.print(); window.close();">
        ${pages.join('')}
      </body>
    </html>
  `);

  win.document.close();
}
save(): void {

  // Your save logic goes here
  // Example: call API or save data

  this.snackBar.open(
    'Saved successfully.',
    'Close',
    {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    }
  );
}

  close(): void {
    this.dialogRef.close();
  }
}